export const NAVIGATION_TEST_IDS = {
    MAIN_LOGO: "top-left-logo",
    MAIN_ELEMENT: "navigation-container",
    FIRST_LVL_ELEMENT: "navigation-first-level-element",
    SECOND_LVL_ELEMENT: "navigation-second-level-element",
    THIRD_LVL_ELEMENT: "navigation-third-level-element",
    LISTING_CHANGING_BUTTON: "listing-changing-button",
    USER_ICON: "user-icon",
    SEARCH_BAR: {
        INPUT: "search-autocomplete",
        COUNTRY_TAB: "country-tab",
        RESULT_ITEM: "results-list-item",
        DROPDOWN: "search-autocomplete-dropdown",
        SEARCH_BUTTON: "searchBarSearchButton",
        INVESTMENT: "search-bar-investment"
    },
    SORT_ICON: "sort-icon",
    BURGER_MENU: "burger-menu",
    SORT_BUTTON: "sort-button",
    SORT_SELECT_BUTTON: "sort-select-button"
};

export const NAVIGATION_MOBILE_TEST_IDS = {
    SEARCH_BAR: {
        INPUT: "search-autocomplete-mobile",
        COUNTRY_TAB: "country-tab-mobile",
        // Mobile homepage hero submit and its counterpart inside the search modal. Both mean "submit
        // the mobile search" and only one of them renders at a time.
        SEARCH_BUTTON: "search-bar-search-button-mobile"
    }
};

export const FOOTER_TEST_IDS = {
    FOOTER_ELEMENT: "footer-nav-container",
    FOOTER_SOCIAL_ICON: "social-media-icon",
    PANEL_EXPAND_WRAPPER: "panel-expandable-wrapper",
    PANEL_EXPANDABLE: "panel-expandable"
};

export const COOKIES_MODAL_IDS = {
    MODAL_BOX: "CybotCookiebotDialog",
    ACCEPT_BUTTON: "CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll"
};

export const FILTERS_TEST_IDS = {
    FILTERS_BOX: "filters-box",
    AREA: "filters-area",
    ACCEPT_BUTTON: "filters-accept-button",
    CLEAN_BUTTON: "filters-clean-button",
    DELIVERY_DATE: "filters-delivery-date",
    ROOMS: "filters-rooms",
    FLOORS: "filters-floors",
    AREA_SIZE: "filters-area-size",
    FILTER_MOBILE_ICON: "filters-mobile-icon",
    HOUSE_TYPES: "filters-house-types",
    ADDITIONAL_SURFACES: "filters-additional-surfaces"
};

export const PROPERTY_CONFIGURATOR_TEST_IDS = {
    NEXT_BUTTON: "property-configurator-next-button",
    PREV_BUTTON: "property-configurator-prev-button",
    ROOM_OPTION: "room-selection-option",
    TOTAL_INPUT: "total-input",
    MONTHLY_INPUT: "monthly-input",
    FAVOURITE_ICON: "favourite-icon"
};

export const HOMEPAGE_TEST_IDS = {
    RECOMMENDED_OFFERS: {
        MORE_OFFERS_BOX: "more-offers-box"
    },
    BLOG_CATEGORIES: {
        VIEW_ARTICLES_BUTTON: "homepage-blog-category-button"
    },
    ARCHITECTS_BUTTON: "homepage-architects-button"
};

export const LISTING_VENDOR_TEST_IDS = {
    CARD: "listing-vendor-card",
    FAVOURITE_ICON: "favourite-icon",
    FIRST_LISTING_ELEMENT: "first-listing-element",
    MAP_CONTAINER: "listing-vendor-map-container",
    PROPERTY_CARD_IMAGE: "property-card-image",
    PROPERTY_CONTAINER: "property-container"
};

export const VENDOR_DETAIL_TEST_IDS = {
    ASK_DEVELOPER_BUTTON: "ask-developer-button"
};

export const PREFERENCES_SURVEY_MODAL_TEST_IDS = {
    WRAPPER: "preferences-survey-modal",
    HEADER_BOX: "preferences-survey-header-box",
    LOCATION_FIELD: "preferences-survey-location",
    SAVE_PREFERENCES_BUTTON: "preferences-survey-save-button",
    SUMMARY_BUTTON: "preferences-survey-summary-button",
    SUMMARY_MODAL: "preferences-survey-summary-modal",
    CLOSE_BUTTON: "preferences-survey-close-button",
    BUDGET_INPUT: "preferences-survey-budget-input",
    CREDIT_PLAN_SWITCH: "preferences-survey-credit-plan-switch"
};
export const NAVIGATION_TEST_IDS = {
    MAIN_LOGO: "top-left-logo",
    MAIN_ELEMENT: "navigation-container",
    FIRST_LVL_ELEMENT: "navigation-first-level-element",
    SECOND_LVL_ELEMENT: "navigation-second-level-element",
    THIRD_LVL_ELEMENT: "navigation-third-level-element",
    LISTING_CHANGING_BUTTON: "listing-changing-button",
    USER_ICON: "user-icon",
    SEARCH_BAR: {
        INPUT: "search-autocomplete",
        COUNTRY_TAB: "country-tab",
        RESULT_ITEM: "results-list-item",
        DROPDOWN: "search-autocomplete-dropdown",
        SEARCH_BUTTON: "searchBarSearchButton",
        INVESTMENT: "search-bar-investment"
    },
    SORT_ICON: "sort-icon",
    BURGER_MENU: "burger-menu",
    SORT_BUTTON: "sort-button",
    SORT_SELECT_BUTTON: "sort-select-button"
};

export const NAVIGATION_MOBILE_TEST_IDS = {
    SEARCH_BAR: {
        INPUT: "search-autocomplete-mobile",
        COUNTRY_TAB: "country-tab-mobile",
        // Mobile homepage hero submit and its counterpart inside the search modal. Both mean "submit
        // the mobile search" and only one of them renders at a time.
        SEARCH_BUTTON: "search-bar-search-button-mobile"
    }
};

export const FOOTER_TEST_IDS = {
    FOOTER_ELEMENT: "footer-nav-container",
    FOOTER_SOCIAL_ICON: "social-media-icon",
    PANEL_EXPAND_WRAPPER: "panel-expandable-wrapper",
    PANEL_EXPANDABLE: "panel-expandable"
};

export const COOKIES_MODAL_IDS = {
    MODAL_BOX: "CybotCookiebotDialog",
    ACCEPT_BUTTON: "CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll"
};

export const FILTERS_TEST_IDS = {
    FILTERS_BOX: "filters-box",
    AREA: "filters-area",
    ACCEPT_BUTTON: "filters-accept-button",
    CLEAN_BUTTON: "filters-clean-button",
    DELIVERY_DATE: "filters-delivery-date",
    ROOMS: "filters-rooms",
    FLOORS: "filters-floors",
    AREA_SIZE: "filters-area-size",
    FILTER_MOBILE_ICON: "filters-mobile-icon",
    HOUSE_TYPES: "filters-house-types",
    ADDITIONAL_SURFACES: "filters-additional-surfaces"
};

export const PROPERTY_CONFIGURATOR_TEST_IDS = {
    NEXT_BUTTON: "property-configurator-next-button",
    PREV_BUTTON: "property-configurator-prev-button",
    ROOM_OPTION: "room-selection-option",
    TOTAL_INPUT: "total-input",
    MONTHLY_INPUT: "monthly-input",
    FAVOURITE_ICON: "favourite-icon"
};

export const HOMEPAGE_TEST_IDS = {
    RECOMMENDED_OFFERS: {
        MORE_OFFERS_BOX: "more-offers-box"
    },
    BLOG_CATEGORIES: {
        VIEW_ARTICLES_BUTTON: "homepage-blog-category-button"
    },
    ARCHITECTS_BUTTON: "homepage-architects-button"
};

export const LISTING_VENDOR_TEST_IDS = {
    CARD: "listing-vendor-card",
    FAVOURITE_ICON: "favourite-icon",
    FIRST_LISTING_ELEMENT: "first-listing-element",
    MAP_CONTAINER: "listing-vendor-map-container",
    PROPERTY_CARD_IMAGE: "property-card-image",
    PROPERTY_CONTAINER: "property-container"
};

export const VENDOR_DETAIL_TEST_IDS = {
    ASK_DEVELOPER_BUTTON: "ask-developer-button"
};

export const PREFERENCES_SURVEY_MODAL_TEST_IDS = {
    WRAPPER: "preferences-survey-modal",
    HEADER_BOX: "preferences-survey-header-box",
    LOCATION_FIELD: "preferences-survey-location",
    SAVE_PREFERENCES_BUTTON: "preferences-survey-save-button",
    SUMMARY_BUTTON: "preferences-survey-summary-button",
    SUMMARY_MODAL: "preferences-survey-summary-modal",
    CLOSE_BUTTON: "preferences-survey-close-button",
    BUDGET_INPUT: "preferences-survey-budget-input",
    CREDIT_PLAN_SWITCH: "preferences-survey-credit-plan-switch"
};
